<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="../../assets/images/pages/vuesax_register.jpg"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Create Account</h4>
                  <p>Fill the below form to create a new account.</p>
                </div>
                <vs-input
                  name="name"
                  label-placeholder="name"
                  v-model="name"
                  class="w-full no-icon-border"
                />
                <vs-input
                  name="email"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full no-icon-border"
                />

                <vs-input
                  type="password"
                  name="password"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                />

                <vs-input
                  type="password"
                  name="conpassword"
                  label-placeholder="Confirm Password"
                  v-model="conpassword"
                  class="w-full mt-6 no-icon-border"
                />

                <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="acceptbox" class="mb-3"
                    >I accept terms and conditions</vs-checkbox
                  >
                  <router-link>Forgot Password?</router-link>
                </div>
                <vs-button
                  class="float-right regisButton"
                  type="border"
                  @click="onRegister"
                  >Register</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      conpassword: "",
      acceptbox: true,
    };
  },
  methods: {
    onRegister() {
      // console.log(this.name);
      // console.log(this.email);
      // console.log(this.password);
      // console.log(this.conpassword);
      // console.log(this.acceptbox);
    }
    // },isDisable(name,email,password,conpassword){
    // }
  },
  computed: {
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #1551b1;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.regisButton {
  margin-bottom: 25px;
}
</style>
